import { z } from 'zod';

/** Previous Currency type:
 * export type Currency = 'GBP' | 'USD' | 'EUR';
 */
export const ZodCurrencySchema = z.enum(['GBP', 'USD', 'EUR']);
export type ZodCurrency = z.infer<typeof ZodCurrencySchema>;

/** Previous Amount type:
 * export type Amount = {
  value: number;
  currency: Currency;
  is_precise?: boolean;
};
 */
const AmountSchema = z.object({
  value: z.number(),
  currency: ZodCurrencySchema,
  is_precise: z.boolean().optional(),
});
export type ZodAmount = z.infer<typeof AmountSchema>;
